import {axiosApi} from "./api.js";
// 登录接口
// export let loginInt = fromdata => {
// 	return axiosApi({
// 		url: "/outer/login/loginInt",
// 		method: "get",
// 		params: {
// 			params: fromdata
// 		}
// 	});
// };

// 专利添加
export let AddPatentInterface = (fromdata) => {
	return axiosApi({
		url: "/api/patent",
		method: "post",
		data:fromdata
	});
};
// 专利删除
export let DeletePatentInterface = (fromdata) => {
	return axiosApi({
		url: "/api/patent",
		method: "DELETE",
		params:fromdata
	});
};
// 专利修改
export let modifyPatentInterface = (fromdata) => {
	return axiosApi({
		url: "/api/patent/update",
		method: "post",
		data:fromdata
	});
};

// 专利获取列表
export let GetlistPatentInterface = (fromdata) => {
	return axiosApi({
		url: "/api/patent/list",
		method: "get",
		params:fromdata
	});
};
// 专利获取单个对象
export let GetObjPatentInterface = (fromdata) => {
	return axiosApi({
		url: "/api/patent",
		method: "get",
		params:fromdata
	});
};


// 上传
export let upload = (fromdata) => {
	return axiosApi({
		url: "/api/upload",
		method: "post",
		data:fromdata
	});
};



// 商标获取列表
export let GetlistTrademarkInterface = (fromdata) => {
	return axiosApi({
		url: "/api/trademark/list",
		method: "get",
		params:fromdata
	});
};


// 商标获取单个对象
export let GetObjTrademarkInterface = (fromdata) => {
	return axiosApi({
		url: "/api/trademark",
		method: "get",
		params:fromdata
	});
};

// 商标添加
export let AddTrademarkInterface = (fromdata) => {
	return axiosApi({
		url: "/api/trademark",
		method: "post",
		data:fromdata
	});
};

// 商标删除
export let DeleteTrademarkInterface = (fromdata) => {
	return axiosApi({
		url: "/api/trademark",
		method: "DELETE",
		params:fromdata
	});
};

// 商标修改
export let modifyTrademarkInterface = (fromdata) => {
	return axiosApi({
		url: "/api/trademark/update",
		method: "post",
		data:fromdata
	});
};


// 软著获取列表
export let GetlistSoftwareInterface = (fromdata) => {
	return axiosApi({
		url: "/api/software/list",
		method: "get",
		params:fromdata
	});
};

// 软著获取单个对象
export let GetObjSoftwareInterface = (fromdata) => {
	return axiosApi({
		url: "/api/software",
		method: "get",
		params:fromdata
	});
};

// 软著添加
export let AddSoftwareInterface = (fromdata) => {
	return axiosApi({
		url: "/api/software",
		method: "post",
		data:fromdata
	});
};
// 软著删除
export let DeleteSoftwareInterface = (fromdata) => {
	return axiosApi({
		url: "/api/software",
		method: "DELETE",
		params:fromdata
	});
};
// 软著修改
export let modifySoftwareInterface = (fromdata) => {
	return axiosApi({
		url: "/api/software/update",
		method: "post",
		data:fromdata
	});
};



// 信息列表
export let GetlistinformationInterface = (fromdata) => {
	return axiosApi({
		url: "/api/information/list",
		method: "get",
		params:fromdata
	});
};
// 信息列表下载次数接口
export let GetInformationInterfaceDownload = (fromdata) => {
	return axiosApi({
		url: "/api/information",
		method: "get",
		params:fromdata
	});
};

// 获取信息列表单个对象
export let GetlistinformationInterfaceObj = (fromdata) => {
	return axiosApi({
		url: "/api/information",
		method: "get",
		params:fromdata
	});
};


